import PropTypes from 'prop-types';

// project imports
import DrawerHeaderStyled from './DrawerHeaderStyled';
import Logo from 'components/logo';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

// ==============================|| DRAWER HEADER ||============================== //

export default function DrawerHeader({ open }) {
  let storedUser = null;
  try {
    storedUser = JSON.parse(localStorage.getItem("user") || sessionStorage.getItem("user") || "null");
  } catch {
    storedUser = null;
  }
  const userName = storedUser?.full_name || localStorage.getItem("full_name") || sessionStorage.getItem("full_name") || storedUser?.username || localStorage.getItem("username") || sessionStorage.getItem("username") || "User";

  return (
    <DrawerHeaderStyled
      open={open}
      sx={{
        minHeight: '60px',
        width: 'initial',
        paddingTop: '8px',
        paddingBottom: '8px',
        paddingLeft: open ? '24px' : 0,
        transition: 'none',
        willChange: 'initial'
      }}
    >
      <Stack direction="row" spacing={1.5} alignItems="center">
        <Logo sx={{ width: open ? 'auto' : 35, height: 35 }} />
      </Stack>
    </DrawerHeaderStyled>
  );
}

DrawerHeader.propTypes = { open: PropTypes.bool };
